import { Operator } from '@procureai/query-builder';

type OperatorType =
  | 'textAuto'
  | 'text'
  | 'relationText'
  | 'num'
  | 'numNotEmpty'
  | 'date'
  | 'single'
  | 'id'
  | 'idAuto'
  | 'enumValue'
  | 'enumValueNotEmpty';

export const operators: Record<OperatorType, Operator[]> = {
  id: [Operator.INEQ, Operator.NINEQ, Operator.EQ, Operator.NE],
  idAuto: [Operator.INEQ, Operator.NINEQ],
  // Backend relation filters (child-table subqueries) support only exact-match
  // operators; IN/NIN map to ilike partial match which the relation clause does
  // not implement.
  relationText: [Operator.EQ, Operator.NE, Operator.INEQ, Operator.NINEQ, Operator.EMPTY, Operator.NOT_EMPTY],
  textAuto: [Operator.IN, Operator.NIN, Operator.EMPTY, Operator.NOT_EMPTY],
  text: [Operator.IN, Operator.NIN, Operator.EQ, Operator.NE, Operator.EMPTY, Operator.NOT_EMPTY],
  enumValueNotEmpty: [Operator.INEQ, Operator.NINEQ, Operator.EQ, Operator.NE],
  enumValue: [Operator.INEQ, Operator.NINEQ, Operator.EQ, Operator.NE, Operator.EMPTY, Operator.NOT_EMPTY],
  num: [Operator.EQ, Operator.NE, Operator.LT, Operator.GT, Operator.BETWEEN, Operator.EMPTY, Operator.NOT_EMPTY],
  numNotEmpty: [Operator.EQ, Operator.NE, Operator.LT, Operator.GT, Operator.BETWEEN],
  date: [Operator.EQ, Operator.NE, Operator.BETWEEN, Operator.LT, Operator.GT, Operator.EMPTY, Operator.NOT_EMPTY],
  single: [Operator.EQ],
};

export const listOperators: Record<string, boolean> = {
  [Operator.IN]: true,
  [Operator.NIN]: true,
  [Operator.INEQ]: true,
  [Operator.NINEQ]: true,
};
